<div *ngIf="selectedRouteExpand" class="container component">

    <div class="linia bar baroptions">
        <options class="mixed-text-icon" [optionstrip]="options" (clickOption)="onClickOption($event)"></options>
    </div>

    <div class="linia bar baroptions">  
        <actions [actionstrip]="actions" (clickAction)="onClickPreAction($event)">
        </actions>
   </div>

    <div class="block-options">
        <div class="llista">
            <ng-container *ngIf="actualOptionId==='PACKAGE'">
                <div class="overflow">
                    <shared-trucking-package-card class="package-item shipmentcard"
                        *ngFor="let package of selectedRouteExpand.packages" [selectedRouteExpand]="selectedRouteExpand"
                        [package]="package" (clickCard)="onClickPackage($event)"
                        [ngClass]="{'selected':selectedPackage!=null && package.packageId==selectedPackage.packageId}"
                        [isDraggable]="false" (refresh)="onRefreshShipmentList($event)">
                    </shared-trucking-package-card>
                </div>
            </ng-container>
            <ng-container *ngIf="actualOptionId==='SHIPMENT'">
                <div class="overflow">
                    <shared-trucking-shipment-card class="shipment-item routedetail"
                        *ngFor="let shipment of selectedRouteExpand.shipments"
                        [selectedRouteExpand]="selectedRouteExpand" [shipment]="shipment"
                        (clickCard)="onClickShipment($event)"
                        [ngClass]="{'selected':selectedShipment!=null && shipment.shipmentId==selectedShipment.shipmentId}">
                    </shared-trucking-shipment-card>
                </div>
            </ng-container>
            <ng-container *ngIf="actualOptionId==='DELIVERY'">
                <shared-documentaryreview-route-item [routeId]="selectedRouteExpand.routeId">
                </shared-documentaryreview-route-item>
            </ng-container>
            <ng-container *ngIf="actualOptionId==='ORDERSHIPMENTSINROUTE'">
                <shared-route-shipment-order [routeId]="selectedRouteExpand.routeId" [onlyvieworder]="true">
                </shared-route-shipment-order>
            </ng-container>
            <ng-container *ngIf="actualOptionId==='ORDERPACKAGESINROUTE'">
                <shared-route-package-order [routeId]="selectedRouteExpand.routeId" [onlyvieworder]="true">
                </shared-route-package-order>
            </ng-container>
        </div>
        <div class="shipmentsPackagesTruckeds-dummy"></div>
        <div *ngIf="shipmentsPackagesTruckeds != null && (shipmentsPackagesTruckeds.shipmentCount > 0 || shipmentsPackagesTruckeds.packageCount > 0)"
            class="banner-truckeds">
            <div class="line">
                <div class="icona"><i class="fa fa-info" aria-hidden="true"></i></div>
                <div class="line boto close">
                    <button class="boleta close" (click)="onClickCloseBanner($event)">
                        <i class="fa fa-times-circle" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
            <div class="texte" [innerHTML]="shipmentsPackagesTruckeds.message | safe: 'html'">
            </div>
        </div>
        <confirmation-dialog *ngIf="truckingAction" [expanded]="askingAction"
            helptitleresource="{{ truckingAction.titleResource }}" helpresource="{{ truckingAction.helpResource }}"
            (onConfirm)="onClickAction(truckingAction.action)" (onCancel)="askingAction = false"></confirmation-dialog>
    </div>
</div>